<template>
  <div>
    <form @submit.prevent="submitQRCodeContactForm">
      <div class="form-group form-group-required" :class="{ 'is-invalid': email && v.email.$invalid }">
        <label class="form-label" for="email">{{ $t('components.qrcode_contact_form.email') }}</label>
        <input
          :id="'email'"
          v-model.trim="email"
          type="email"
          :name="'email'"
          class="form-control"
          :class="{ 'is-invalid': email && v.email.$invalid }">
        <div v-if="email && !v.email.required" class="invalid-feedback">{{ $t('form.validation.required') }}</div>
        <div v-if="email && !v.email.email" class="invalid-feedback">{{ $t('form.validation.email') }}</div>
      </div>

      <div class="form-group form-group-required" :class="{ 'is-invalid': message && v.message.$invalid }">
        <label class="form-label" for="message">{{ $t('components.qrcode_contact_form.message') }}</label>
        <textarea
          :id="'message'"
          v-model.trim="message"
          maxlength="500"
          :name="'message'"
          class="form-control"
          :placeholder="$t('components.qrcode_contact_form.placeholder.message')"
          :class="{ 'is-invalid': message && v.message.$invalid }" />
        <div v-if="message && !v.message.required" class="invalid-feedback">{{ $t('form.validation.required') }}</div>
        <div v-if="!message" class="form-text text-end mt-2">{{ messageMaxLength }} caractères maximum</div>
        <div v-if="message" class="form-text text-end mt-2">{{ messageMaxLength - message.length }} caractères restants</div>
      </div>

      <div class="d-flex justify-content-center gap-3">
        <button type="button" class="btn btn-outline-primary btn-rounded" @click.prevent="$emit('cancel')">
          {{ $t('actions.cancel') }}
        </button>
        <button class="btn btn-primary btn-rounded" type="submit" :disabled="v.$invalid">
          {{ $t('actions.send') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import useVuelidate from '@vuelidate/core';
import { email, maxLength, required } from '@vuelidate/validators';
import { defineComponent } from 'vue';
import { useToast } from 'vue-toast-notification';
import { mapState } from 'vuex';

export default defineComponent({
  name: 'QRCodeContactForm',
  emits: ['on-submit', 'cancel'],
  setup() {
    const toast = useToast();
    const v = useVuelidate();
    return { toast, v };
  },
  data() {
    return {
      email: '',
      message: '',
      messageMaxLength: 500,
    };
  },
  computed: {
    ...mapState('recruiter', [
      'user',
    ]),
  },
  mounted() {
    this.email = this.user.email;
  },
  validations() {
    return {
      email: {
        required,
        email,
      },
      message: {
        required,
        maxLength: maxLength(500),
      },
    };
  },
  methods: {
    async submitQRCodeContactForm(): Promise<void> {
      try {
        const payload = { email: this.email, message: this.message };
        await window.ky.post('/qr-code-contact/', { json: payload }).json();
        this.$emit('on-submit');
        this.toast.success((this.$t('components.qrcode_contact_form.success') as string));
      } catch {
        this.toast.error((this.$t('components.qrcode_contact_form.error') as string));
      }
    },
  },
});

</script>
